export default __webpack_public_path__ + "static/media/rtr-180-moto.37a596f0.png";